import { isEmptyString } from '../utils';

const isValidKey = key => Object.values(STORE_KEYS).includes(key);

const isValidValue = (key, value) => value == null || typeof value == VALUE_TYPES[key];

const convertToAppropriateType = (value, type) => {
    if (value == null) return null;
    let convertedValue = null;
    switch (type) {
        case "boolean": convertedValue = value === "true"; break;
        case "number": convertedValue = Number(value); break;
        case "object": convertedValue = JSON.parse(value); break;
        default: convertedValue = value; break;
    }
    return convertedValue;
};

const convertToString = (value, type) => {
    if (value == null) return null;
    let convertedValue = null;
    switch (type) {
        case "object": convertedValue = JSON.stringify(value); break;
        case "boolean":
        case "number":
        default: convertedValue = value.toString(); break;
    }
    return convertedValue;
};

const getItem = key => {
    if (isEmptyString(key) || !isValidKey(key)) throw new Error("Invalid Key");
    return convertToAppropriateType(localStorage.getItem(key), VALUE_TYPES[key]);
};

const setItem = (key, value) => {
    if (isEmptyString(key) || !isValidKey(key)) throw new Error("Invalid Key");
    if (!isValidValue(key, value)) throw new Error("Invalid Value");
    localStorage.setItem(key, convertToString(value, VALUE_TYPES[key]));
};

const removeItem = key => {
    if (isEmptyString(key) || !isValidKey(key)) throw new Error("Invalid Key");
    localStorage.removeItem(key);
};

export default Object.freeze({
    getItem,
    setItem,
    removeItem,
});

// Add new unique keys and their value types whenever you want to store and retrieve
export const STORE_KEYS = Object.freeze({
    ACCESS_TOKEN: 'access_token',
    USER_PROFILE: 'user_profile',
    CYCLIC_BANNER1_INDEX: 'cyclic_banner1_index',
    CYCLIC_FOOTER1_INDEX: 'cyclic_footer1_index',
    DEVICE_ID: 'device_id',
});

const VALUE_TYPES = Object.freeze({
    'access_token': 'string',
    'user_profile': 'object',
    'cyclic_banner1_index': 'number',
    'cyclic_footer1_index': 'number',
    'device_id': 'string',
});
